import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerDataDictionaryIssuesRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-data-dictionary-issues',
	path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/data-dictionaries/:dictionaryId/issues/:objectAttributeId',
	exact: true,
};
